import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import { SettlementPendingEntry } from '../giftSupplySettlement/giftSupplySettlement.interface';

export type SettlementPendingPurpose = 'supply' | 'rebate';

// GiftAgent 유저는 /gift-seller 포털 진입 후 giftBrandRole()이 LowerRole.Admin을 반환하므로
// 백엔드 prefix는 /admin을 사용한다. LowerRole.GiftAgent는 이 API에서 쓰이지 않는다.
export type SettlementPendingRole =
  | LowerRole.Admin
  | LowerRole.BugoAgencyAdmin
  | LowerRole.GiftBrandSeller;

export interface SettlementPendingFilter {
  /** supply 대상 업체 id (purpose=supply, admin 전용) */
  giftItemBrand?: string;
  /** rebate 대상 상조 id (purpose=rebate, admin 전용) */
  bugoBrand?: string;
  /** 배송완료일 시작 (ISO 문자열) */
  deliveredFrom?: string;
  /** 배송완료일 종료 (ISO 문자열) */
  deliveredTo?: string;
}

/**
 * 정산 예정(미정산) 배송 조회.
 *
 * - admin: purpose 필수, 대상 필터 가능 (GiftAgent도 /admin prefix 사용)
 * - bugo-agency-admin: purpose 고정 rebate, 본인 상조 자동
 * - gift-brand-seller: purpose 고정 supply, 본인 브랜드 자동
 */
export const getSettlementPending = async (
  purpose: SettlementPendingPurpose,
  filter: SettlementPendingFilter = {},
  role: SettlementPendingRole = LowerRole.Admin,
): Promise<SettlementPendingEntry[]> => {
  const params = new URLSearchParams();

  // bugo-agency-admin / gift-brand-seller는 purpose가 고정이지만 쿼리로 보내도 무해
  params.set('purpose', purpose);

  if (filter.giftItemBrand) params.set('giftItemBrand', filter.giftItemBrand);
  if (filter.bugoBrand) params.set('bugoBrand', filter.bugoBrand);
  if (filter.deliveredFrom) params.set('deliveredFrom', filter.deliveredFrom);
  if (filter.deliveredTo) params.set('deliveredTo', filter.deliveredTo);

  const { data } = await api_.get<SettlementPendingEntry[]>(
    `/${role}/gift-delivery/settlement-pending?${params.toString()}`,
  );
  return data;
};
